<template>
  <div>
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class='p-4'>
              <div class='modal-title pb-2'>
                <slot name='modal-title' />
                <span class='modal-close-btn actionable' @click='emitCloseModal()'>
                  <img class='modal-close-btn' src='static/assets/img/SVGIcons/icon-close-circle-blue.svg'>
                </span>
              </div>
              <slot name="modal-body" />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  methods: {
    emitCloseModal: function() {
      let vm = this;
      vm.$emit("closemodal");
    }
  }
};
</script>

<style scoped lang='scss'>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: top;
}

.modal-container {
  width: 100%;
  max-width: 850px;
  margin: 0px auto;
  padding: 0px;
  background-color: $white;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  overflow: hidden;
}

.modal-header {
  padding: 0px 0px 10px 0px;
}

.modal-close-btn {
  float: right;
  font-size: 20px;
  color: $gray-dk;
  height: 25px;
  width: 25px;
}

.modal-title {
  font-size: 20px;
  color: $blue-lt;
}

.modal-subtitle {
  font-size: 14px;
}

.modal-body {
  // max-height: 65vh !important;
  max-height: 600px !important;
  padding: 0px !important;
  position: relative !important;

  .modal-close-icon {
    position: absolute;
    top: 15px;
    right: 15px;
    width: 30px;
    cursor: pointer;

    &.close-icon-gray {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AaModal/AaModal.vue